const ITEMS = [
  "100% Satvik",
  "No Onion",
  "No Garlic",
  "Fresh Ghee Rotis",
  "Hot At Your Station",
  "Pure Jain Kitchen",
  "Order 60 Min Ahead",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="overflow-hidden border-y border-amber-900/10 bg-emerald-900 py-4" data-testid="marquee-band">
      <div className="animate-marquee flex w-max items-center gap-10">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10 whitespace-nowrap">
                <span className="font-display text-lg font-semibold italic tracking-wide text-amber-100">
                  {item}
                </span>
                <span className="h-1.5 w-1.5 rounded-full bg-amber-500" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
